import FlexPane from './_flex-pane.js'
import ImageButton from './_image-button.js'
import Text from './_text.js'
import Button from './_button.js'
import Intent from './_intent.js'

export default {
  name: 'QuickStartGuideBanner',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '8px 8px 8px 0',
          alignItems: 'center',
        },
      },
    },
    closeButton: {
      configSet: ImageButton,
      configValues: {
        button: {
          style: {
            base: {
              alignItems: 'center',
              flexGrow: 0,
              minWidth: '40px',
              minHeight: '40px',
            },
          },
        },
        buttonIcon: {
          src: 'close-thin',
          style: {
            minWidth: '8px',
            minHeight: '8px',
          },
        },
      },
    },
    text: {
      configSet: Text,
      configValues: {
        container: {
          padding: '0 16px 0 0',
        },
      },
    },
    openGuideButton: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            minHeight: '40px',
            alignItems: 'center',
            flexGrow: 0,
            flexShrink: 0,
            padding: '8px',
          },
        },
      },
    },
    openGuideIntent: {
      configSet: Intent,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
